<es-details-card [info]="info" [canEdit]="canEdit" [isMissing]="isEmpty" (edit)="onEdit()">
  <div class="row" *ngIf="importer && importer.entityIdentifier">
    <div class="col-6 card-label">{{ "LABELS.ID_NUMBER" | translate }}</div>
    <div class="col-6">
      <ng-template [ngIf]="importer.entityIdentifierQualifier !== null">
        {{ ("IDENTIFIER_QUALIFIER." + importer.entityIdentifierQualifier | translate) + " " }}
      </ng-template>
      {{ importer.entityIdentifier | identifier }}
    </div>
  </div>
  <div class="row" *ngIf="importer && importer.name">
    <div class="col-6 card-label">{{ "LABELS.NAME" | translate }}</div>
    <div class="col-6">{{ importer.name }}</div>
  </div>
  <div class="row" *ngIf="importer && importer.address">
    <div class="col-6 card-label">{{ "LABELS.ADDRESS" | translate }}</div>
    <div class="col-6">
      <address-details [address]="importer.address"></address-details>
    </div>
  </div>
  <div class="error-message" *ngFor="let message of allValidationMessages">{{ "BACK_ERROR." + message.text | translate }}</div>
</es-details-card>
